import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-exercise-completion-dialog',
  templateUrl: './exercise-completion-dialog.component.html',
  styleUrls: ['./exercise-completion-dialog.component.css']
})
export class ExerciseCompletionDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
